import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 680020 663090"
    {...props}
  >
    <path
      d="m492134 314169 120774-182645-205066 76772L340340 0l-67822 208196-204946-77092 120484 182825L0 426103l218076 19790-29570 216966 151444-158164 151204 158395-29230-216997 218096-19470z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
